import React from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { ImmunizationSeriesEvent } from "../models/Interfaces";
import { getDateTime } from "../utils/data";

interface EventCardProps {
  index: number;
  event: ImmunizationSeriesEvent;
  vaccine: string;
}

export default function EventCard({ event, vaccine, index }: EventCardProps) {
  const { t } = useTranslation();

  const readableDate = (date: string) => {
    return getDateTime(date).toLocaleString();
  };

  return (
    <div className="p-4 event-card flex flex-col dark:bg-white max-md:bg-white max-md:p-2 mobile-card">
      {(event.description || vaccine) && (
        <div
          role="paragraph"
          className="text-dark font-black text-lg"
          data-testid="event-card-title"
        >
          {`${event.description || vaccine}`}
        </div>
      )}
      {event.dateAdministered && (
        <div
          role="paragraph"
          className="text-dark flex text-md"
          data-testid="event-card-administered"
        >
          <p className="font-black">{`${t("immunizations.records_event_administered")}`}</p>
          &nbsp;
          <p className="font-semibold">{readableDate(event.dateAdministered)}</p>
        </div>
      )}
      {event.administeredAtFacility && (
        <div role="paragraph" className="text-dark flex text-md" data-testid="event-card-facility">
          <p className="font-black">{`${t("immunizations.records_event_provider")}`}</p>
          &nbsp;
          <p className="font-semibold">{event.administeredAtFacility}</p>
        </div>
      )}
      {event.manufacturer && (
        <div
          role="paragraph"
          className="text-dark flex text-md"
          data-testid="event-card-manufacturer"
        >
          <p className="font-black">{`${t("immunizations.records_event_manufacturer")}`}</p>
          &nbsp;
          <p className="font-semibold">{event.manufacturer}</p>
        </div>
      )}
      {event.lot && (
        <div role="paragraph" className="text-dark text-md flex" data-testid="event-card-lot">
          <p className="font-black">{`${t("immunizations.records_event_lot")}`}</p>
          &nbsp;
          <p className="font-semibold">{event.lot}</p>
        </div>
      )}
      {parseInt(event?.doseNumberInSeries || "0") > 0 && (
        <div role="paragraph" className="text-dark flex text-md" data-testid="event-card-dose">
          <p className="font-black">{`${t("immunizations.records_event_dose_number")}`}</p>
          &nbsp;
          <p className="font-semibold">{event.doseNumberInSeries}</p>
        </div>
      )}
    </div>
  );
}
